const exportUrl = {
  exportDebtData: '/erp/count/exportDebtData', // 导出应收欠款明细详情
  exportDebtDtails: '/erp/count/exportDebtDtails', // 导出应收欠款明细
  exportDeductData: '/erp/count/exportDeductData', // 导出划扣金额明细详情
  exportDeductDtails: '/erp/count/exportDeductDtails', // 导出划扣金额明细
  exportDiscoutData: '/erp/count/exportDiscoutData', // 导出优惠明细列表详情
  exportDiscoutDtails: '/erp/count/exportDiscoutDtails', // 导出优惠明细列表
  exportIncomeData: '/erp/count/exportIncomeData', // 导出收入明细列表详情
  exportIncomeDetail: '/erp/count/exportIncomeDetail', // 导出收入明细列表
  exportFastIncome: '/erp/income/exportFastIncome', // 导出快捷收银数据
  exportItemDetails: '/erp/income/exportItemDetails', // 项目收入 - 导出详情
  exportItemIncome: '/erp/income/exportItemIncome', // 项目收入 - 导出分类汇总页面数据
  exportItemPool: '/erp/income/exportItemPool', // 项目收入 - 导出项目汇总页面数据
  exportProductDetails: '/erp/income/exportProductDetails', // 导出产品收入页面详情数据
  exportProductIncome: '/erp/income/exportProductIncome', // 导出产品收入页面数据
  exportVipCardDetails: '/erp/income/exportVipCardDetails', // 导出套餐收入详情数据
  exportVipCardIncome: '/erp/income/exportVipCardIncome', // 导出套餐收入数据
  exportMemberCount: '/erp/analyse/exportMemberCount', // 导出客流明细分析
  exportCustomerAndMember: '/erp/analyse/exportCustomerAndMember', // 导出新增顾客明细
  exportBookDetails: '/erp/situation/exportBookDetails', // 导出预约明细
  exportBookRoom: '/erp/situation/exportBookRoom', // 导出房间预订
  exportBookServe: '/erp/situation/exportBookServe', // 导出预约项目
  exportBookServeDetails: '/erp/situation/exportBookServeDetails', // 导出预约项目详情
  exportBookSource: '/erp/situation/exportBookSource', // 导出预约来源
  exportBookTechnician: '/erp/situation/exportBookTechnician', // 导出预约统称
  exportBookTechnicianDetails: '/erp/situation/exportBookTechnicianDetails', // 导出预约统称详情
  exportAchivement: '/erp/achivement/exportAchivement', // 导出营业概况
  exportPercentageCount: '/erp/achivement/exportPercentageCount', // 导出提成概况
  exportProductDtails: '/erp/achivement/exportProductDtails', // 导出某员工产品详情
  exportServeSaleDtails: '/erp/achivement/exportServeSaleDtails', // 导出员工项目详情  (这个接口地址不对)
  exportStaffAchivement: '/erp/achivement/exportStaffAchivement', // 导出员工业绩与提成
  exportVipCardDtails: '/erp/achivement/exportVipCardDtails', // 导出某员工套餐详情
  exportServeDtails: '/erp/achivement/exportServeDtails', // 导出员工项目详情
  getItemDetails: '/erp/income/getItemDetails', // 项目收入-项目汇总详情页面
  // 5.1导出新接口
  exportPackageSaleItemDetails: '/erp/achivement/exportPackageSaleItemDetails', // （5.1）导出员工套餐销售明细
  exportProductSaleItemDetails: '/erp/achivement/exportProductSaleItemDetails', // （5.1）导出员工产品销售明细
  exportServeItemDetails: '/erp/achivement/exportServeItemDetails', // （5.1）导出员工项目劳动明细
  exportServeSaleDetails: '/erp/achivement/exportServeSaleDetails', // （5.1）导出员工项目销售详情
  exportServeSaleItemDetails: '/erp/achivement/exportServeSaleItemDetails', // （5.1）导出员工项目销售明细
  // 5.2导出新接口
  exportDayStaffErrorOrderMsgList: '/erp/achivement/exportDayStaffErrorOrderMsgList', // （5.2）导出已处理的异常订单详情列表（按照日期）
  exportOneStaffFinishErrorOrderMsgList: '/erp/achivement/exportOneStaffFinishErrorOrderMsgList', // （5.2）导出已处理的异常订单详情列表（某一天）
  exportVipCardDeduct: '/erp/analyse/exportVipCardDeduct', // 5.2导出套餐划扣
  exportVipCardSaleDetailPage: '/erp/analyse/exportVipCardSaleDetailPage', // （5.2）导出套餐销售（下面的分页数量）
  exportIncomeDetails: '/erp/count/exportIncomeDetails', // 5.2导出支付明细详情模板
  exportPayDetails: '/erp/count/exportPayDetails', // 5.2导出支付明细模板
  exportRefundAnalyse: '/erp/count/exportRefundAnalyse', // 5.2导出退款明细详情模板
  exportRefundDtails: '/erp/count/exportRefundDtails', // （5.2导出退款明细模板）
  // 5.5 导出接口
  exportLookSellDTO: '/erp/achivement/exportLookSellDTO', // （5.5）导出销售达标详情
  exportSellDetailDTO: '/erp/achivement/exportSellDetailDTO', // （5.5）导出销售达标详情明细
  exportWorkDetailDTO: '/erp/achivement/exportWorkDetailDTO', // （5.5）导出劳动达标详情明细
  exportWorkDTO: '/erp/achivement/exportWorkDTO', // （5.5）导出劳动达标详情
  exportRoomDetail: '/erp/situation/exportRoomDetail', // (5.6)导出房间预定
  exportDeductWorkDTO: '/erp/achivement/exportDeductWorkDTO', // (5.6)导出劳动达标-区分划扣详情
  exportDeductServeDtails: '/erp/achivement/exportDeductServeDtails', // (5.6)导出员工项目劳动-区分划扣详情
  exportOrderTotalDTO: '/erp/achivement/exportOrderTotalDTO', // （5.7）导出业绩订单详情
  // 5.9 导出接口
  exportBeautyPackageList: '/erp/lookVipCard/exportBeautyPackageList', // (5.9)导出美容套餐列表
  // 5.10 导出接口
  exportItemSaleRiseList: '/erp/saleStatistics/exportItemSaleRiseList', // 5.10导出销售分析-项目分析增长明细
  exportProductSaleRiseList: '/erp/saleStatistics/exportProductSaleRiseList', // 5.10导出销售分析-产品分析增长明细
  exportTechnicianSaleAnalyseMsg: '/erp/saleStatistics/exportTechnicianSaleAnalyseMsg', // 5.10导出销售分析-员工销售明细
  exportTechnicianServeAnalyseMsg: '/erp/saleStatistics/exportTechnicianServeAnalyseMsg', // 5.10导出销售分析-员工劳动明细
  exportBookRoomBed: '/erp/situation/exportBookRoomBed', // 5.10 导出台位预定
  exportRoomBedDetail: '/erp/situation/exportRoomBedDetail', // 5.10 导出台位预定详情
  // 6.1
  exportGiftStatistics: '/erp/saleStatistics/exportGiftStatistics', // 6.10 导出赠品统计
  // 6.7
  exportTechnicianBook: '/erp/situation/exportTechnicianBook', // 导出预约技师分析
  exportTechnicianBookDetail: '/erp/situation/exportTechnicianBookDetail', // 导出预约技师分析详情

};
export default {
  // 导出收入明细列表
  exportIncomeDetail(beginTime, endTime, timeCountType) {
    return [exportUrl.exportIncomeDetail, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出优惠明细列表
  exportDiscoutDtails(beginTime, endTime, timeCountType) {
    return [exportUrl.exportDiscoutDtails, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出划扣金额明细列表
  exportDeductDtails(beginTime, endTime, timeCountType) {
    return [exportUrl.exportDeductDtails, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出应收欠款明细列表
  exportDebtDtails(beginTime, endTime, timeCountType) {
    return [exportUrl.exportDebtDtails, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出分类汇总明细列表
  exportItemIncome(beginTime, endTime, text, isRead, timeCountType) {
    return [exportUrl.exportItemIncome, beginTime, endTime, null, text, null, null, null, null, null, null, null, isRead, null, null, timeCountType];
  },
  // 导出项目汇总明细列表
  exportItemPool(beginTime, endTime, text, isRead, timeCountType) {
    return [exportUrl.exportItemPool, beginTime, endTime, null, text, null, null, null, null, null, null, null, isRead, null, null, timeCountType];
  },
  // 导出产品收入明细列表
  exportProductIncome(beginTime, endTime, text, pageNum, timeCountType) {
    return [exportUrl.exportProductIncome, beginTime, endTime, null, text, pageNum, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出套餐收入数据列表
  exportVipCardIncome(beginTime, endTime, text, isRead, timeCountType) {
    return [exportUrl.exportVipCardIncome, beginTime, endTime, null, text, null, null, null, null, null, null, isRead, null, null, null, null, timeCountType];
  },
  // 导出快捷收银明细列表
  exportFastIncome(beginTime, endTime, text, timeCountType) {
    return [exportUrl.exportFastIncome, beginTime, endTime, text, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出收入详情明细详情列表
  exportIncomeData(dateTime, timeCountType) {
    return [exportUrl.exportIncomeData, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出优惠详情明细列表
  exportDiscoutData(dateTime, timeCountType) {
    return [exportUrl.exportDiscoutData, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出划扣金额详情明细列表
  exportDeductData(dateTime, timeCountType) {
    return [exportUrl.exportDeductData, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出应收欠款详情明细列表
  exportDebtData(dateTime, timeCountType) {
    return [exportUrl.exportDebtData, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 导出业绩概况详情明细列表
  exportAchivement(beginTime, endTime, countType) {
    return [exportUrl.exportAchivement, beginTime, endTime, null, null, null, countType];
  },
  // 导出提成概况详情明细列表
  exportPercentageCount(beginTime, endTime) {
    return [exportUrl.exportPercentageCount, beginTime, endTime];
  },
  // 导出员工业绩与提成详情明细列表
  exportStaffAchivement(beginTime, endTime, text, isRead) {
    return [exportUrl.exportStaffAchivement, beginTime, endTime, text, null, null, null, null, null, null, isRead];
  },
  // 导出项目销售详情明细列表
  // exportServeSaleDtails(beginTime, endTime, technicianId) {
  //   downloadFile(exportUrl.exportServeSaleDtails, beginTime, endTime, null, null, null, null, technicianId);
  // },
  // 导出产品详情明细列表
  exportProductDtails(beginTime, endTime, technicianId) {
    return [exportUrl.exportProductDtails, beginTime, endTime, null, null, null, null, technicianId];
  },
  // 导出套餐详情明细列表
  exportVipCardDtails(beginTime, endTime, technicianId) {
    return [exportUrl.exportVipCardDtails, beginTime, endTime, null, null, null, null, technicianId];
  },
  // 导出项目详情明细列表
  exportServeDtails(beginTime, endTime, technicianId) {
    return [exportUrl.exportServeDtails, beginTime, endTime, null, null, null, null, technicianId];
  },

  // 导出预约明细列表
  exportBookDetails(beginTime, endTime, sort, sortBy) {
    return [exportUrl.exportBookDetails, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },
  // 导出预约来源列表
  exportBookSource(beginTime, endTime, sort, sortBy) {
    return [exportUrl.exportBookSource, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },
  // 导出预约项目列表
  exportBookServe(beginTime, endTime, sort, sortBy) {
    return [exportUrl.exportBookServe, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },
  // 导出预约统称列表
  exportBookTechnician(beginTime, endTime, sort, sortBy) {
    return [exportUrl.exportBookTechnician, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },

  // 导出房间预订列表
  exportBookRoom(beginTime, endTime, sort, sortBy) {
    return [exportUrl.exportBookRoom, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },
  // 导出房间预订列表
  exportBookRoomBed(beginTime, endTime, sort, sortBy) {
    return [exportUrl.exportBookRoomBed, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },
  // 导出预约项目详情列表
  exportBookServeDetails(dateTime, isAsc) {
    return [exportUrl.exportBookServeDetails, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, isAsc];
  },
  // 导出预约统称详情列表
  exportBookTechnicianDetails(dateTime, isAsc) {
    return [exportUrl.exportBookTechnicianDetails, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, isAsc];
  },
  // 导出预约技师分析
  exportTechnicianBook(beginTime, endTime, sort, sortBy) {
    return [exportUrl.exportTechnicianBook, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },
  //  导出预约技师分析详情
  exportTechnicianBookDetail(beginTime, endTime, technicianId, isAsc) {
    return [exportUrl.exportTechnicianBookDetail, beginTime, endTime, null, null, null, null, technicianId, null, null, null, null, null, null, null, isAsc];
  },
  // 导出顾客分析详情列表
  exportMemberCount(beginTime, endTime, dateType) {
    return [exportUrl.exportMemberCount, beginTime, endTime, dateType];
  },
  // 导出顾客分析详情列表
  exportCustomerAndMember(beginTime, endTime, dateType) {
    return [exportUrl.exportCustomerAndMember, beginTime, endTime, dateType];
  },
  // 导出项目详情列表
  exportItemDetails(beginTime, endTime, itemId, timeCountType) {
    return [exportUrl.exportItemDetails, beginTime, endTime, null, null, null, null, null, Number(itemId), null, null, null, null, null, null, null, timeCountType];
  },
  // 导出产品详情列表
  exportProductDetails(beginTime, endTime, productId, timeCountType) {
    return [exportUrl.exportProductDetails, beginTime, endTime, null, null, null, null, null, null, Number(productId), null, null, null, null, null, null, timeCountType];
  },
  // 导出套餐详情列表
  exportVipCardDetails(beginTime, endTime, vipCardId, timeCountType) {
    return [exportUrl.exportVipCardDetails, beginTime, endTime, null, null, null, null, null, null, null, Number(vipCardId), null, null, null, null, null, timeCountType];
  },

  // 5.1导出新接口
  // （5.1）导出员工套餐销售明细
  exportPackageSaleItemDetails(beginTime, endTime, technicianId, vipCardId) {
    return [exportUrl.exportPackageSaleItemDetails, beginTime, endTime, null, null, null, null, technicianId, null, null, Number(vipCardId)];
  },
  // （5.1）导出员工产品销售明细
  exportProductSaleItemDetails(beginTime, endTime, technicianId, productId) {
    return [exportUrl.exportProductSaleItemDetails, beginTime, endTime, null, null, null, null, technicianId, null, Number(productId)];
  },
  // （5.1）导出员工项目劳动明细
  exportServeItemDetails(beginTime, endTime, pageNum, technicianId, itemId) {
    return [exportUrl.exportServeItemDetails, beginTime, endTime, null, null, pageNum, null, technicianId, Number(itemId)];
  },
  // （5.1）导出员工项目销售详情
  exportServeSaleDetails(beginTime, endTime, technicianId) {
    return [exportUrl.exportServeSaleDetails, beginTime, endTime, null, null, null, null, technicianId];
  },
  // （5.1）导出员工项目销售明细
  exportServeSaleItemDetails(beginTime, endTime, technicianId, itemId) {
    return [exportUrl.exportServeSaleItemDetails, beginTime, endTime, null, null, null, null, technicianId, Number(itemId)];
  },
  // （5.2）导出已处理的异常订单详情列表（按照日期）
  exportDayStaffErrorOrderMsgList(beginTime, endTime, technicianId) {
    return [exportUrl.exportDayStaffErrorOrderMsgList, beginTime, endTime, null, null, null, null, technicianId];
  },
  // （5.2）导出已处理的异常订单详情列表（某一天）
  exportOneStaffFinishErrorOrderMsgList(beginTime, endTime, technicianId) {
    return [exportUrl.exportOneStaffFinishErrorOrderMsgList, beginTime, endTime, null, null, null, null, technicianId];
  },
  // （5.2）导出已处理的异常订单详情列表（某一天）
  exportVipCardDeduct(beginTime, endTime, sortKeyWord, sortType, dateType) {
    return [exportUrl.exportVipCardDeduct, null, beginTime, endTime, sortKeyWord, sortType, dateType];
  },
  // （5.2）导出套餐销售（下面的分页数量）
  exportVipCardSaleDetailPage(startTime, endTime, sortKeyWord, sortType, dateType) {
    return [exportUrl.exportVipCardSaleDetailPage, startTime, null, endTime, sortKeyWord, sortType, dateType];
  },
  // 5.2导出支付明细详情模板
  exportIncomeDetails(dateTime, timeCountType) {
    return [exportUrl.exportIncomeDetails, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 5.2导出支付明细模板
  exportPayDetails(beginTime, endTime, timeCountType) {
    return [exportUrl.exportPayDetails, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 5.2导出退款明细详情模板
  exportRefundAnalyse(dateTime, timeCountType) {
    return [exportUrl.exportRefundAnalyse, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // 5.2导出退款明细模板
  exportRefundDtails(beginTime, endTime, timeCountType) {
    return [exportUrl.exportRefundDtails, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null, timeCountType];
  },
  // （5.5）导出员工销售达标详情
  exportLookSellDTO(beginTime, endTime, technicianId) {
    return [exportUrl.exportLookSellDTO, beginTime, endTime, null, null, null, null, technicianId];
  },
  // （5.5）导出员工劳动达标详情
  exportWorkDTO(beginTime, endTime, technicianId) {
    return [exportUrl.exportWorkDTO, beginTime, endTime, null, null, null, null, technicianId];
  },
  // （5.1）导出员工销售达标明细
  exportSellDetailDTO(beginTime, endTime, technicianId, standardId) {
    return [exportUrl.exportSellDetailDTO, beginTime, endTime, null, null, null, null, technicianId, null, null, null, Number(standardId)];
  },
  // （5.1）导出员工劳动达标明细
  exportWorkDetailDTO(beginTime, endTime, technicianId, standardId) {
    return [exportUrl.exportWorkDetailDTO, beginTime, endTime, null, null, null, null, technicianId, null, null, null, Number(standardId)];
  },
  //  (5.6) 导出房间预定（ 缺少）
  exportRoomDetail(dateTime, sort, sortBy) {
    return [exportUrl.exportRoomDetail, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },
  // （5.5）导出员工劳动达标详情
  exportDeductWorkDTO(beginTime, endTime, technicianId) {
    return [exportUrl.exportDeductWorkDTO, beginTime, endTime, null, null, null, null, technicianId];
  },
  // 导出项目详情明细列表
  exportDeductServeDtails(beginTime, endTime, technicianId) {
    return [exportUrl.exportDeductServeDtails, beginTime, endTime, null, null, null, null, technicianId];
  },
  // （5.7）导出业绩订单详情
  exportOrderTotalDTO(beginTime, endTime, technicianId) {
    return [exportUrl.exportOrderTotalDTO, beginTime, endTime, null, null, null, null, technicianId];
  },
  // (5.9)导出美容套餐列表
  exportBeautyPackageList(phone, useType) {
    return [exportUrl.exportBeautyPackageList, phone, useType];
  },
  // 5.10导出销售分析-项目分析增长明细
  exportItemSaleRiseList(beginTime, endTime, dateType) {
    return [exportUrl.exportItemSaleRiseList, beginTime, endTime, dateType];
  },
  // 5.10导出销售分析-产品分析增长明细
  exportProductSaleRiseList(beginTime, endTime, dateType) {
    return [exportUrl.exportProductSaleRiseList, beginTime, endTime, dateType];
  },
  // 5.10导出销售分析-员工销售明细
  exportTechnicianSaleAnalyseMsg(beginTime, endTime, dateType) {
    return [exportUrl.exportTechnicianSaleAnalyseMsg, beginTime, endTime, dateType];
  },
  // 5.10导出销售分析-员工劳动明细
  exportTechnicianServeAnalyseMsg(beginTime, endTime, dateType) {
    return [exportUrl.exportTechnicianServeAnalyseMsg, beginTime, endTime, dateType];
  },

  // 导出房间预订列表
  exportRoomBedDetail(dateTime, sort, sortBy) {
    return [exportUrl.exportRoomBedDetail, null, null, dateTime, null, null, null, null, null, null, null, null, null, null, null, null, null, null, sort, sortBy];
  },

  // 6.10 导出赠品统计
  exportGiftStatistics(beginTime, endTime) {
    return [exportUrl.exportGiftStatistics, beginTime, endTime, null];
    // return [exportUrl.exportItemIncome, beginTime, endTime, null, null, null, null, null, null, null, null, null, null, null, null, null];
  },
};
